import type { ReportType, UploadState } from '@/constants/schema-constants'
import { Material } from '@/dtos/commons'

export class ReportFilesSearchPostRequest {
  reportTypes?: ReportType[] = []
  uploadStates?: UploadState[] = []
  buildings?: string[] = []
  period?: number | null | undefined = null
  targetYearMonth?: string | null | undefined = null
  skip!: number
  take!: number

  constructor(
    skip: number,
    take: number,
  ) {
    this.skip = skip
    this.take = take
  }
}

export class ReportFile {
  reportUploadId!: string
  buildingId!: string
  buildingName!: string
  reportType!: ReportType
  uploadOrder?: number
  period!: number
  targetYearMonth!: string
  uploadState!: UploadState
  material?: Material | null | undefined = null
  version!: number
}

export class ReportFilesSearchPostResponse {
  reportFiles!: ReportFile[]
  periodList?: number[]
  targetYearMonthList?: string[]
  reportFilesCount?: number
  constructor(reportFiles: ReportFile[]) {
    this.reportFiles = reportFiles
  }
}
